import axios from "axios";
import store from "../store/store";
import { login } from "../store/authSlice";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ✅ Login API          
//Login.jsx
export const loginApi = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/user/login-user`, formData);
    const { token, refreshToken, user } = response.data;

    // ✅ Store in localStorage
    localStorage.setItem("authToken", token);
    localStorage.setItem("refreshToken", refreshToken || "");
    localStorage.setItem("user", JSON.stringify(user));
    if (user?.id) {
      localStorage.setItem("user_id", user.id);
    }

    // ✅ Dispatch login action
    store.dispatch(login({ user, token }));

    return response.data; // Return full response
  } catch (error) {
    console.error("Login error:", error.response?.data?.message || error.message);
    throw new Error(error.response?.data?.message || "Login failed");
  }
};

// ✅ Signup API (Send OTP)
//SignUp.jsx
export const signUpApi = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/user/sendOtp`, formData);
    return response.data; // Return API response
  } catch (error) {
    console.error("Signup error:", error.response?.data?.message || error.message);
    throw new Error(error.response?.data?.message || "Signup failed");
  }
};

// ✅ Verify OTP & Set Password API
//sendOtp.jsx
export const verifyOtpApi = async (otpData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/user/verifyOtp`, otpData);
    return response.data; // Return API response
  } catch (error) {
    console.error("OTP Verification error:", error.response?.data?.message || error.message);
    throw new Error(error.response?.data?.message || "OTP verification failed");
  }
};

// ✅ Reset Password API
//resetPassword.jsx
export const resetPasswordApi = async (password, token) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/user/update-password`, {
      password,
      token, // The reset token from URL params
    });

    return response.data; // Return API response data
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong!");
  }
};

// ✅ Forgot Password - Send OTP API
// forgotPassword.jsx
export const forgotPasswordApi = async (phone) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/user/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to send OTP");
    }

    return data; // API response message
  } catch (error) {
    throw new Error(error.message || "Something went wrong. Please try again.");
  }
};

// ✅ Verify OTP for Forgot Password API
// forgotPassword.jsx
export const verifyForgotOtpApi = async (phone, otp) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/user/verifyOtpForgotPassword`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone, otp }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "OTP verification failed");
    }

    return data; // API response message
  } catch (error) {
    throw new Error(error.message || "Something went wrong. Please try again.");
  }
};
